import * as React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, LinearProgress, TextField, FormControl, FormGroup, InputLabel, MenuItem, Select, Card, CardContent, Button, CardActions } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import './BlacklistModal.scss';
import { UnidentifiedProductsGrid } from "./UnidentifiedProductsGrid";
import Rest from "src/services/Rest";

interface IProductData {
    id: string;
    sku: string;
    isbn: string;
    descricao: string;
    qtd_cupom: number;
    data_ultima_sellout: string;
}

interface IBlacklistModalProps {
    open: boolean;
    handleClose: () => void;
    title: string;
    onClose(): void;
}

interface IBlacklistModalState {
    content: IProductData[] | null;
    error: string;
    loading: boolean;
    page: number;
    search: {
        descricao: string;
        isbn: string;
        page: number;
        size: number;
        sku: string;
    };
    totalItems: number;

}

class BlacklistModal extends React.Component<IBlacklistModalProps, IBlacklistModalState> {
    constructor(props: IBlacklistModalProps) {
        super(props);
        this.state = {
            content: null,
            error: "",
            loading: false,
            page: 0,
            search: {
                descricao: "",
                isbn: "",
                page: 0,
                size: 10,
                sku: "",
            },
            totalItems: 0,

        };

        this.handleChangePage = this.handleChangePage.bind(this);

    }

    public componentDidMount() {
        if (this.props.open) {
            this.loadBlacklistedProducts();
        }
    }

    public componentDidUpdate(prevProps: IBlacklistModalProps) {
        if (this.props.open && !prevProps.open) {
            this.loadBlacklistedProducts();
        }
    }

    public async loadBlacklistedProducts() {
        try {
            const { page, size, sku, isbn, descricao } = this.state.search;

            this.setState({ loading: true });

            const endPoint = "unidentified-products/blacklist";
            let queryParam = `?page=${page}&pageSize=${size}`;

            queryParam += this.getParams(sku, isbn, descricao);

            const finalUrl = `${endPoint}${queryParam}`;
            const response = await Rest.GET(finalUrl, null);
            const result = await response.json();

            if (result) {
                const blacklistData = result.products.map((item: any) => ({
                    descricao: item.descricao,
                    id: item.id,
                    isbn: item.isbn,
                    sku: item.sku,
                }));

                this.setState({ content: blacklistData, totalItems: result.total });
            }
        } catch (error) {
            console.error("Erro ao buscar lista negra:", error);
            this.setState({ loading: false, error: error.message });
        } finally {
            this.setState({ loading: false });
        }
    }

    public handleChangePage = async (ev: any, page: number) => {
        const search = this.state.search;
        search.page = page;
        await this.setSearch(search);
        this.loadBlacklistedProducts();
    };

    public render() {
        const { open, handleClose, title } = this.props;
        const { search } = this.state;
        const { page, size } = search;

        const { content, loading, error, totalItems } = this.state;

        return (
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={"md"} PaperProps={{ style: { width: "1100px", height: "600px" } }}>
                <DialogTitle className="dialogTitle">
                    {title}
                    <IconButton onClick={handleClose} className="closeButton">
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Card>
                        <CardContent>
                            <form>
                                <FormGroup className="search-bar-grid-blacklist" row={true}>
                                    <TextField
                                        label="SKU"
                                        value={this.state.search.sku}
                                        onChange={(event) => this.handleInputChange("sku", event.target.value)}
                                        style={this.textFieldStyle()}
                                        type="text"
                                        autoComplete="text"
                                        margin="normal"
                                        required={false}
                                    />
                                    <TextField
                                        label="ISBN"
                                        value={this.state.search.isbn}
                                        onChange={(event) => this.handleInputChange("isbn", event.target.value)}
                                        style={this.textFieldStyle()}
                                        type="text"
                                        autoComplete="text"
                                        margin="normal"
                                        required={false}

                                    />
                                    <TextField
                                        label="Descrição"
                                        value={this.state.search.descricao}
                                        onChange={(event) => this.handleInputChange("descricao", event.target.value)}
                                        style={this.textFieldStyle()}
                                        type="text"
                                        autoComplete="text"
                                        margin="normal"
                                        required={false}
                                    />
                                    <FormControl
                                        required={true}
                                        margin="normal"
                                        style={this.textFieldStyle()}
                                    >
                                        <InputLabel>Tamanho da pagina</InputLabel>
                                        <Select
                                            value={this.state.search.size}
                                            onChange={this.handleChangeCadastro}
                                            inputProps={{
                                                id: 'size',
                                                name: 'size',
                                            }}
                                        >
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={50}>50</MenuItem>
                                            <MenuItem value={100}>100</MenuItem>
                                        </Select>
                                    </FormControl>
                                </FormGroup>
                            </form>
                        </CardContent>
                        <CardActions>
                            <Button
                                className="filter-dialog-clear"
                                onClick={this.clear}
                            >
                                Limpar
                            </Button>
                            <Button
                                className="filter-dialog-close"
                                color="primary"
                                onClick={() => this.loadBlacklistedProducts()}
                            >
                                Pesquisar
                            </Button>
                        </CardActions>
                        {loading && <LinearProgress />}
                        {!loading && content && (
                            <UnidentifiedProductsGrid
                                error={error}
                                loading={loading}
                                items={[
                                    { header: "SKU", row: "sku" },
                                    { header: "ISBN", row: "isbn" },
                                    { header: "Descrição", row: "descricao" },
                                ]}
                                rows={content}
                                onViewRow={(product: any) => this.deleteFromBlackList(product)}
                                handleChangePage={this.handleChangePage}
                                dialogTitle="Excluir da lista negra"
                                dialogContent="Deseja realmente excluir este item?"
                                tooltipTitle="Excluir da lista negra"
                                tableProps={{
                                    limit: size,
                                    page,
                                    total: totalItems,
                                }}
                            />
                        )}
                    </Card>
                </DialogContent>
            </Dialog>
        );
    }

    private handleInputChange = (field: string, value: string) => {
        const updatedSearch = Object.assign({}, this.state.search, { [field]: value });
        this.setState({ search: updatedSearch });
    };

    private textFieldStyle(): React.CSSProperties | undefined {
        return {
            marginLeft: 5,
            marginRight: 5,
        };
    }

    private handleChangeCadastro = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        const { name, value } = event.target;
        if (name) {
            const updatedSearch = Object.assign({}, this.state.search, { [name]: value as string });
            await this.setSearch(updatedSearch);
            this.loadBlacklistedProducts();
        }
    };

    private setSearch = async (search: {
        descricao: string;
        isbn: string;
        page: number;
        size: number;
        sku: string;
    }) => {
        this.setState({ search });
    };

    private clear = () => {
        this.setState({
            search: {
                descricao: "",
                isbn: "",
                page: this.state.search.page,
                size: 10,
                sku: "",
            }
        });
    }

    private getParams = (sku: string, isbn: string, descricao: string) => {
        let queryParam = "";

        if (!!sku) {
            queryParam += `&sku=${sku}`;
        }

        if (!!isbn) {
            queryParam += `&isbn=${isbn}`;
        }

        if (!!descricao) {
            queryParam += `&descricao=${descricao}`;
        }
        return queryParam;
    };

    private async deleteFromBlackList(product: any): Promise<void> {
        try {
            const response = await Rest.DELETE(`unidentified-products/delete-from-blacklist`, product.id);
            if (response.status === 200) {
                this.loadBlacklistedProducts();
            } else {
                throw new Error("Erro ao excluir item da lista negra");
            }
        } catch (error) {
            throw new Error(`Erro ao excluir item da lista negra: ${error.message}`);
        }
    }
}

export default BlacklistModal;



// WEBPACK FOOTER //
// ./src/component/administration/unidentified-products-list/BlacklistModal.tsx